exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.swal2-container {\n    z-index: 9999;\n}\n", ""]);

// exports
